import { render, staticRenderFns } from "./ExportBtn.vue?vue&type=template&id=63278fb9&scoped=true"
import script from "./ExportBtn.vue?vue&type=script&lang=js"
export * from "./ExportBtn.vue?vue&type=script&lang=js"
import style0 from "./ExportBtn.vue?vue&type=style&index=0&id=63278fb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63278fb9",
  null
  
)

export default component.exports